/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2022-11-10 10:12:00
 */

 import * as Vue from "vue-tsx-support";
 import {Component, Prop} from 'vue-property-decorator'
 import "vue-tsx-support/enable-check"
 import Modal from "src/types/iview/Modal";
 import Button from "src/types/iview/Button";
 import {modalFactory} from "src/util/vueExtend";
 import ErrorFile from "./component/errorFile";
 import '../solutionKey/solutionKey.less'
 
 export namespace SolutionKeyDetailVOI {
    export interface PropsI {
        id: number
        name: string
        error_no:string
    }
 }

 @Component
class SolutionKeyDetailModal extends Vue.Component<SolutionKeyDetailVOI.PropsI> {
	@Prop({
		type: Number
	})
    id: number
    
    @Prop({
		type: String
	})
	name: string
    
    @Prop({
		type: String
	})
	error_no: string

	visible: boolean = false


	close () {
		this.closeModal()
	}

	closeModal() {
		this.visible = false
		this.$emit('close', false)
    }
    


	render (h) {
		return (
			<Modal
				title={this.name + " | " + this.error_no}
                width="1100"
                class-name="wqms-data-audit-modal"
				v-model={this.visible}
				mask-closable={false}
                on-on-cancel={this.close}
                footer-hide
			>
			<ErrorFile id={this.id}></ErrorFile>
			</Modal>
		);
	}
}

export default function alertSolutionKeyDetailModal (id: number, name: string, error_no: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
        modalFactory<SolutionKeyDetailVOI.PropsI>(SolutionKeyDetailModal)({
            id,
            name,
            error_no
        })
        resolve()
    })
}

